import React, {Component} from 'react';
import '../styles/Home.css'
import Footer from "../shared/Footer";
import AplikacjaMobilna from "../home/homeComponents/AplikacjaMobilna";
import {NotificationManager} from "react-notifications";

export default class Konto extends Component {

    constructor(props) {
        super(props);

        this.state = {
            onRegister: false,
        }
    }

    componentDidMount() {
        if (this.props.zmianaHasla === true) {
            NotificationManager.success("", "Hasło zostało zmienione. Zaloguj się ponownie używając nowego hasła ", 5000);
        }
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik no-animation">
                <div className="container text-center">
                    <h2><b>Załóż konto by uzyskać nowe możliwości!</b></h2>
                    <h4>Dzięki rejestracji uzyskasz dostęp do danych o swoich biletach, oraz informacje o kursach
                        eventowych.</h4>
                </div>
            </div>
            <div style={{background: '#efefef'}} className="matrix">
                <div className="container paddingContainerMobilka" style={{padding: 15}}>
                    {this.props.children}
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/Konto.js